import {Customer} from "../../../model/customer/customer";
import {Injectable} from "@angular/core";
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {CommonFieldService} from "../../common/common-field.service";
import {FieldsService} from "../../common/fields-service";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {TranslateService} from "@ngx-translate/core";
import {AccountTraderComponent} from "../../../crystal-clear/customer/account-trader/account-trader.component";
import {AccountTrader} from "../../../model/customer/account-trader";
import {Trader} from "../../../model/customer/trader";
import {Owner} from "../../../model/customer/owner";

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountTraderDataLoadingService {

  //fields
  exchangeCodes: FieldRecord<any>[] = [];

  owners: FieldRecord<Owner>[] = [];

  customers: FieldRecord<Customer>[] = [];
  displayedCustomers: FieldRecord<Customer>[] = [];

  accounts: FieldRecord<AccountDefinition>[] = [];
  displayedAccounts: FieldRecord<AccountDefinition>[] = [];

  traders: FieldRecord<Trader>[] = [];

  constructor(private readonly commonFieldService: CommonFieldService,
              private readonly fieldsService: FieldsService,
              private readonly translateService: TranslateService) {
  }

  loadData(component: AccountTraderComponent) {

    this.fieldsService.loadField(this.customers, () => this.commonFieldService.getCustomers(FieldRequest.DEFAULT()), component.tracker, (records) => {
      this.filterCustomers(component.formRecord);
    });
    this.fieldsService.loadField(this.exchangeCodes, () => this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()), component.tracker, (records) => {
      let defaultAllExchange = FieldRecord.DEFAULT();
      defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
      defaultAllExchange.id = ExchangeDetail.ALL_TEXT;
      this.exchangeCodes.unshift(defaultAllExchange);
      this.filterAccounts(component.formRecord);
    });
    this.fieldsService.loadField(this.accounts, () => this.commonFieldService.getAccounts(FieldRequest.DEFAULT()), component.tracker, (records) => {
      this.filterAccounts(component.formRecord);
    });
    this.fieldsService.loadField(this.owners, () => this.commonFieldService.getOwners(FieldRequest.DEFAULT()), component.tracker, (records) => {
      if (records?.length) {
        component.newRecord.owner = records[0].text;
        if (component.formRecord) {
          component.formRecord.owner = records[0].text;
          this.filterCustomers(component.formRecord);
        }
      }
    });
    this.fieldsService.loadField(this.traders, () => this.commonFieldService.getTraders(FieldRequest.DEFAULT()), component.tracker);
  }


  public filterAccounts(formRecord: AccountTrader) {
    if (this.accounts && formRecord) {
      const customerField = this.customers.find(field => formRecord.customerName === field.value.code);
      if (customerField) {
        this.displayedAccounts = this.accounts.filter((field, i, arr) =>
          field.value.customerId == customerField.value.id
          && (!field.value.exchangeCode || field.value.exchangeCode.length === 0
            || field.value.exchangeCode === ExchangeDetail.ALL
            || field.value.exchangeCode === ExchangeDetail.ALL_TEXT
            || formRecord.exchangeCode === field.value.exchangeCode
            || formRecord.exchangeCode === ExchangeDetail.ALL
            || formRecord.exchangeCode === ExchangeDetail.ALL_TEXT)
          && arr.findIndex(t => t.text === field.text) === i);
      } else {
        this.displayedAccounts = [];
      }
    } else {
      this.displayedAccounts = [];
    }
  }

  public filterCustomers(formRecord: AccountTrader) {
    if (this.customers && formRecord) {
      this.displayedCustomers = this.customers.filter(field => {
        return formRecord.owner === field.value.owner;
      });
    } else {
      this.displayedCustomers = [];
    }
  }
}
